import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateShopLocationDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddLocation(shop: { id: string }) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("post", "/shops/{shopId}/locations");
  const invalidateShop = useInvalidateShop(shop.id);

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (requestBody: CreateShopLocationDto) => {
      return mutation.mutateAsync({ params: { path: { shopId: shop.id } }, body: requestBody });
    },
  });
}
